import { FeatureSwitch } from '@if/core/types'

export type FeatureFlags = FeatureSwitch['id']

export const getFeatureFlags = (featureSwitch: FeatureSwitch[]) => {
  return featureSwitch.reduce(
    (acc, feature) => {
      acc[feature.id] = feature.isActivated
      return acc
    },
    {} as Record<FeatureFlags, boolean>,
  )
}
